/* Enchantling — theme scripts */
(function () {
  'use strict';
  var T = window.theme || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '${{amount}}';
    function withDelims(n, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var v;
    switch (key) {
      case 'amount_no_decimals': v = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': v = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = withDelims(cents, 2, "'", '.'); break;
      default: v = withDelims(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  T.formatMoney = formatMoney;

  /* ---------- Countdown bar ---------- */
  function initCountdown() {
    $$('[data-countdown]').forEach(function (el) {
      var mode = el.dataset.mode, end;
      var key = el.dataset.key;
      var minutes = parseInt(el.dataset.minutes, 10) || 60;
      function newEvergreenEnd() {
        var e = Date.now() + minutes * 60000;
        try { sessionStorage.setItem(key, String(e)); } catch (err) {}
        return e;
      }
      if (mode === 'fixed') {
        end = Date.parse(el.dataset.end);
        if (isNaN(end)) end = Date.now() + minutes * 60000;
      } else {
        var stored = null;
        try { stored = parseInt(sessionStorage.getItem(key), 10); } catch (err) {}
        end = stored && stored > Date.now() ? stored : newEvergreenEnd();
      }
      var d = $('[data-days]', el), h = $('[data-hours]', el), m = $('[data-minutes]', el), s = $('[data-seconds]', el);
      function tick() {
        var left = end - Date.now();
        if (left <= 0) {
          if (mode === 'fixed') { left = 0; } else { end = newEvergreenEnd(); left = end - Date.now(); }
        }
        var sec = Math.floor(left / 1000);
        d.textContent = pad(Math.floor(sec / 86400));
        h.textContent = pad(Math.floor((sec % 86400) / 3600));
        m.textContent = pad(Math.floor((sec % 3600) / 60));
        s.textContent = pad(sec % 60);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- Drawers & modals ---------- */
  function openLayer(el) {
    if (!el) return;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  }
  function closeLayer(el) {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .modal.is-open')) document.body.classList.remove('no-scroll');
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openLayer(document.getElementById(opener.dataset.drawerOpen)); return; }
    var mOpen = t.closest('[data-modal-open]');
    if (mOpen) { e.preventDefault(); openLayer(document.getElementById(mOpen.dataset.modalOpen)); return; }
    var closer = t.closest('[data-drawer-close], [data-modal-close]');
    if (closer) { e.preventDefault(); closeLayer(closer.closest('.drawer, .modal')); return; }
    var cartOpen = t.closest('[data-cart-open]');
    if (cartOpen && T.cartType === 'drawer' && $('[data-cart-drawer]')) { e.preventDefault(); openCart(); return; }
    var lineBtn = t.closest('[data-line-change]');
    if (lineBtn) { e.preventDefault(); changeLine(lineBtn.dataset.lineChange, lineBtn.dataset.qty); return; }
    var tab = t.closest('[data-size-tabs] .size-tab');
    if (tab) {
      var wrap = tab.closest('.modal__panel');
      $$('.size-tab', wrap).forEach(function (b) { b.classList.toggle('is-active', b === tab); });
      var cm = tab.dataset.unit === 'cm';
      $$('[data-in]', wrap).forEach(function (x) { x.hidden = cm; });
      $$('[data-cm]', wrap).forEach(function (x) { x.hidden = !cm; });
      return;
    }
    var top = t.closest('[data-scroll-top]');
    if (top && (top.getAttribute('href') || '').charAt(0) === '#') {
      e.preventDefault();
      var target = $('[data-product-section]') || document.body;
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.drawer.is-open, .modal.is-open').forEach(closeLayer);
  });

  /* ---------- Cart ---------- */
  var cartTimerInt;
  function startCartTimer() {
    var el = $('[data-cart-timer]');
    if (!el || !T.cartTimer) return;
    var key = 'cart-reserved-until', end;
    try { end = parseInt(sessionStorage.getItem(key), 10); } catch (e) {}
    if (!end || end < Date.now()) {
      end = Date.now() + (T.cartTimerMinutes || 5) * 60000;
      try { sessionStorage.setItem(key, String(end)); } catch (e) {}
    }
    clearInterval(cartTimerInt);
    function tick() {
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var node = $('[data-cart-timer]');
      if (node) node.textContent = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
      if (left === 0) clearInterval(cartTimerInt);
    }
    tick(); cartTimerInt = setInterval(tick, 1000);
  }
  function refreshCart(open) {
    refreshing = true;
    return fetch(T.routes.root_url.replace(/\/$/, '') + '/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var wrap = document.getElementById('shopify-section-cart-drawer');
        if (wrap && data['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-drawer'];
          var fresh = tmp.querySelector('[data-cart-drawer]');
          var old = wrap.querySelector('[data-cart-drawer]');
          if (fresh && old) {
            var wasOpen = old.classList.contains('is-open');
            old.replaceWith(fresh);
            if (wasOpen || open) openLayer(fresh);
          }
        }
        return fetch(T.routes.cart_url + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        return enforceAddons(cart).then(function (res) {
          if (res.changed) {
            if (T.isCartPage) { if (res.removedAll) reloadWithNote(); else location.reload(); return cart; }
            return refreshCart(open).then(function (c) { if (res.removedAll) showAddonNote(); return c; });
          }
          updateCount(cart);
          if (mainCount(cart) > 0) startCartTimer();
          return cart;
        });
      })
      .then(function (c) { refreshing = false; return c; }, function (e) { refreshing = false; throw e; });
  }

  /* ---------- Add-on rules (an add-on can never be bought without a hoodie) ---------- */
  function isProtection(item) { return T.protectionProductId && item.product_id === T.protectionProductId; }
  function isAddon(item) {
    return isProtection(item) || String(item.product_type || '').toLowerCase() === String(T.addonType || 'add-on');
  }
  function mainCount(cart) {
    return cart.items.reduce(function (n, it) { return isAddon(it) ? n : n + it.quantity; }, 0);
  }
  function updateCount(cart) {
    var n = mainCount(cart);
    $$('[data-cart-count]').forEach(function (c) { c.textContent = n; c.classList.toggle('is-empty', n === 0); });
  }
  function showAddonNote() {
    $$('[data-addon-note]').forEach(function (n) { n.hidden = false; });
  }
  function reloadWithNote() {
    try { sessionStorage.setItem('addon-note', '1'); } catch (e) {}
    location.reload();
  }
  // Works out which add-on lines must change. With no hoodie, every add-on goes.
  // With hoodies: shipping protection is capped at 1 per order, other add-ons at one per hoodie.
  function addonUpdates(cart) {
    var mains = mainCount(cart), updates = {}, changed = false, removedAll = false;
    var protectionLeft = 1, perProduct = {};
    cart.items.forEach(function (it) {
      if (!isAddon(it)) return;
      var want;
      if (mains === 0) { want = 0; removedAll = true; }
      else if (isProtection(it)) { want = Math.min(it.quantity, protectionLeft); protectionLeft -= want; }
      else {
        var used = perProduct[it.product_id] || 0;
        want = Math.max(0, Math.min(it.quantity, mains - used));
        perProduct[it.product_id] = used + want;
      }
      if (want !== it.quantity) { updates[it.key] = want; changed = true; }
    });
    return { updates: updates, changed: changed, removedAll: removedAll };
  }
  T.addonUpdates = addonUpdates;
  var enforcing = false;
  function enforceAddons(cart) {
    var res = addonUpdates(cart);
    if (!res.changed || enforcing) return Promise.resolve({ changed: false });
    enforcing = true;
    return nativeFetch(T.routes.cart_update_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: res.updates })
    }).then(function () { return res; }, function () { return { changed: false }; })
      .then(function (r) { enforcing = false; return r; });
  }
  function checkCart() {
    return nativeFetch(T.routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (cart) {
      var res = addonUpdates(cart);
      if (!res.changed) { updateCount(cart); return cart; }
      return refreshCart(false);
    });
  }
  // Same safety net the reference store uses: whenever anything (theme or app) changes the cart, re-check it.
  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input) {
    var p = nativeFetch.apply(window, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (!enforcing && /\/cart\/(change|update|add|clear)/.test(url) && !/[?&]addon-check/.test(url)) {
        p.then(function () { setTimeout(function () { if (!refreshing) checkCart(); }, 250); });
      }
    } catch (e) {}
    return p;
  };
  var refreshing = false;
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('[data-protect-toggle]')) return;
    var row = t.closest('[data-protect]');
    var panel = $('[data-cart-drawer] .drawer__panel');
    if (panel) panel.classList.add('is-loading');
    var req = t.checked
      ? addItems([{ id: parseInt(row.dataset.variant, 10), quantity: 1 }])
      : nativeFetch(T.routes.cart_change_url + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: parseInt(row.dataset.line, 10), quantity: 0 })
        });
    req.catch(function () {}).then(function () { return refreshCart(); });
  });
  // Never let checkout start until the cart has been checked.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-checkout-form]') || form.dataset.checked === '1') return;
    var submitter = e.submitter;
    if (submitter && submitter.name !== 'checkout') return;
    e.preventDefault();
    nativeFetch(T.routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (cart) {
      var res = addonUpdates(cart);
      if (res.changed) {
        return enforceAddons(cart).then(function () {
          if (T.isCartPage) { if (res.removedAll) reloadWithNote(); else location.reload(); }
          else refreshCart(true).then(function () { if (res.removedAll) showAddonNote(); });
        });
      }
      if (mainCount(cart) === 0) { showAddonNote(); return; }
      form.dataset.checked = '1';
      var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = '1';
      form.appendChild(h);
      form.submit();
    });
  });
  function openCart() { openLayer($('[data-cart-drawer]')); startCartTimer(); }
  function changeLine(line, qty) {
    var panel = $('[data-cart-drawer] .drawer__panel');
    if (panel) panel.classList.add('is-loading');
    fetch(T.routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: Math.max(0, parseInt(qty, 10)) })
    }).then(function () { return refreshCart(); });
  }
  function addItems(items) {
    return fetch(T.routes.cart_add_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
        return j;
      });
    });
  }
  T.addItems = addItems;

  /* ---------- Rotator ---------- */
  function initRotators() {
    $$('[data-rotator]').forEach(function (r) {
      var items = $$('[data-rotator-item]', r);
      if (items.length < 2) return;
      var i = 0, ms = (parseInt(r.dataset.interval, 10) || 5) * 1000;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, ms);
    });
  }

  /* ---------- Product page ---------- */
  function initProduct(section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var variants = product.variants;
    var picker = $('[data-variant-picker]', section);
    var current = variants.filter(function (v) { return String(v.id) === String(new URLSearchParams(location.search).get('variant')); })[0]
      || variants.filter(function (v) { return v.available; })[0] || variants[0];

    /* Gallery */
    var track = $('[data-gallery-track]', section);
    var slides = track ? $$('.product-gallery__slide', track) : [];
    var thumbs = $$('[data-thumb-index]', section);
    var counter = $('[data-gallery-counter]', section);
    var idx = 0;
    function goTo(i, smooth) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[idx].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(idx);
    }
    function setActive(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      var th = thumbs[i], wrap = $('[data-gallery-thumbs]', section);
      if (th && wrap) wrap.scrollTo({ left: th.offsetLeft - wrap.clientWidth / 2 + th.clientWidth / 2, behavior: 'smooth' });
    }
    if (track) {
      var scrollT;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollT);
        scrollT = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== idx) { idx = i; setActive(i); }
        }, 80);
      });
      var start = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      if (start > 0) requestAnimationFrame(function () { goTo(start, false); });
    }
    var prev = $('[data-gallery-prev]', section), next = $('[data-gallery-next]', section);
    if (prev) prev.addEventListener('click', function () { goTo(idx - 1); });
    if (next) next.addEventListener('click', function () { goTo(idx + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.dataset.thumbIndex, 10)); }); });
    var tw = $('[data-gallery-thumbs]', section);
    var tp = $('[data-thumbs-prev]', section), tn = $('[data-thumbs-next]', section);
    if (tp && tw) tp.addEventListener('click', function () { tw.scrollBy({ left: -tw.clientWidth * 0.8, behavior: 'smooth' }); });
    if (tn && tw) tn.addEventListener('click', function () { tw.scrollBy({ left: tw.clientWidth * 0.8, behavior: 'smooth' }); });
    function showMedia(mediaId) {
      if (!mediaId) return;
      var i = slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(mediaId); });
      if (i >= 0) goTo(i);
    }

    /* Variant selection */
    function selectedOptions() {
      return $$('.variant-option', picker).map(function (opt) {
        var checked = $('input[data-option-input]:checked', opt);
        if (checked) return checked.value;
        var sel = $('select[data-option-input]', opt);
        return sel ? sel.value : null;
      });
    }
    function findVariant(opts) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }
    function setPickerTo(v) {
      if (!picker) return;
      $$('.variant-option', picker).forEach(function (opt, i) {
        var val = v.options[i];
        $$('input[data-option-input]', opt).forEach(function (inp) { inp.checked = inp.value === val; });
        var sel = $('select[data-option-input]', opt); if (sel) sel.value = val;
        var lbl = $('[data-option-value]', opt); if (lbl) lbl.textContent = val;
      });
    }
    function updateAvailability() {
      if (!picker) return;
      var opts = selectedOptions();
      $$('.variant-option', picker).forEach(function (opt, i) {
        $$('.pill', opt).forEach(function (p) {
          var inp = $('input', p);
          var test = opts.slice(); test[i] = inp.value;
          var v = findVariant(test);
          p.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function updatePrice(v) {
      var save = v.compare_at_price > v.price ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
      $$('[data-price]').forEach(function (e) { e.textContent = formatMoney(v.price); });
      $$('[data-compare]').forEach(function (e) { e.textContent = formatMoney(v.compare_at_price || 0); e.hidden = !save; });
      $$('[data-save]').forEach(function (e) { e.hidden = !save; var p = $('[data-save-pct]', e); if (p) p.textContent = save; });
    }
    var atc = $('[data-add-to-cart]', section);
    var atcText = atc ? $('[data-atc-text]', atc) : null;
    var atcLabel = atcText ? atcText.textContent : '';
    function onVariantChange(v, fromUser) {
      if (!v) {
        if (atc) { atc.disabled = true; atcText.textContent = 'Unavailable'; }
        return;
      }
      current = v;
      setPickerTo(v);
      updatePrice(v);
      updateAvailability();
      if (atc) { atc.disabled = !v.available; atcText.textContent = v.available ? atcLabel : 'Sold out'; }
      if (v.featured_media && fromUser) showMedia(v.featured_media.id);
      var sticky = $('[data-sticky-variant]'); if (sticky) sticky.value = v.id;
      if (fromUser && history.replaceState) {
        var url = new URL(location.href); url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
      if (bundle) bundle.refresh();
    }
    if (picker) {
      picker.addEventListener('change', function () {
        onVariantChange(findVariant(selectedOptions()), true);
      });
    }

    /* Bundle */
    var bundle = initBundle(section, product, function () { return current; }, onVariantChange);

    /* Quantity */
    var qtyInput = $('[data-qty-input]', section);
    var qm = $('[data-qty-minus]', section), qp = $('[data-qty-plus]', section);
    if (qm) qm.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    if (qp) qp.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });

    /* Add to cart */
    var err = $('[data-atc-error]', section);
    function addToCart() {
      if (!current || !current.available) return;
      var items = bundle ? bundle.items() : [{ id: current.id, quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1 }];
      if (!bundle && qtyInput == null) items = [{ id: current.id, quantity: 1 }];
      if (atc) { atc.disabled = true; atcText.textContent = 'Adding…'; }
      if (err) err.hidden = true;
      addItems(items).then(function () {
        if (T.cartType === 'drawer' && $('[data-cart-drawer]')) return refreshCart(true);
        location.href = T.routes.cart_url;
      }).catch(function (e) {
        if (err) { err.textContent = e.message; err.hidden = false; }
      }).then(function () {
        if (atc) { atc.disabled = !current.available; atcText.textContent = atcLabel; }
      });
    }
    if (atc) atc.addEventListener('click', addToCart);

    /* Sticky ATC */
    var sticky = $('[data-sticky-atc]');
    if (sticky && atc) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
      io.observe(atc);
      var sv = $('[data-sticky-variant]', sticky);
      if (sv) sv.addEventListener('change', function () {
        var v = variants.filter(function (x) { return String(x.id) === sv.value; })[0];
        onVariantChange(v, true);
      });
      var sb = $('[data-sticky-add]', sticky);
      if (sb) sb.addEventListener('click', addToCart);
    }

    onVariantChange(current, false);
  }

  function initBundle(section, product, getCurrent, onVariantChange) {
    var root = $('[data-bundle]', section);
    if (!root) return null;
    var bars = $$('[data-bar]', root);
    var upsells = $$('[data-upsell]', root);
    var itemSelections = {}; // bar qty -> array of variant ids
    var optionNames = product.options.map(function (o) { return typeof o === 'string' ? o : o.name; });

    function selectedBar() { return bars.filter(function (b) { return b.classList.contains('is-selected'); })[0] || bars[0]; }

    function buildItemRows(bar) {
      var qty = parseInt(bar.dataset.qty, 10);
      var box = $('[data-bar-items]', bar);
      if (!box || product.variants.length < 2) return;
      var cur = getCurrent();
      var sel = itemSelections[qty] || [];
      sel[0] = cur.id;
      for (var i = 1; i < qty; i++) if (!sel[i]) sel[i] = cur.id;
      itemSelections[qty] = sel;
      box.innerHTML = '';
      sel.forEach(function (vid, i) {
        var v = product.variants.filter(function (x) { return x.id === vid; })[0] || cur;
        var row = document.createElement('span');
        row.className = 'bundle-item';
        var html = '<span class="bundle-item__n">#' + (i + 1) + '</span>';
        optionNames.forEach(function (name, oi) {
          var values = product.options[oi].values || unique(product.variants.map(function (x) { return x.options[oi]; }));
          html += '<span class="select-wrap select-wrap--sm"><select data-item="' + i + '" data-opt="' + oi + '" aria-label="' + esc(name) + ' for item ' + (i + 1) + '">';
          values.forEach(function (val) {
            html += '<option value="' + esc(val) + '"' + (v.options[oi] === val ? ' selected' : '') + '>' + esc(val) + '</option>';
          });
          html += '</select><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg></span>';
        });
        row.innerHTML = html;
        box.appendChild(row);
      });
    }
    function unique(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }
    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('.bundle-bar__radio')) {
        bars.forEach(function (b) { b.classList.toggle('is-selected', $('.bundle-bar__radio', b) === t); });
        refresh();
        return;
      }
      if (t.matches('select[data-item]')) {
        var bar = t.closest('[data-bar]');
        var qty = parseInt(bar.dataset.qty, 10);
        var i = parseInt(t.dataset.item, 10);
        var opts = $$('select[data-item="' + i + '"]', bar).map(function (s) { return s.value; });
        var v = product.variants.filter(function (x) { return x.options.every(function (o, k) { return o === opts[k]; }); })[0];
        if (v) {
          itemSelections[qty][i] = v.id;
          if (i === 0) onVariantChange(v, true);
        }
        return;
      }
      if (t.matches('[data-upsell-check]')) {
        var up = t.closest('[data-upsell]');
        if (up.classList.contains('is-free') && !t.checked) { t.checked = true; }
        up.classList.toggle('is-checked', t.checked);
        return;
      }
      if (t.matches('select[data-upsell-variant]')) { refreshUpsellPrices(); }
    });
    root.addEventListener('click', function (e) {
      if (e.target.closest('select')) e.stopPropagation();
    }, true);

    function refreshUpsellPrices() {
      var bar = selectedBar();
      var freeOn = bar && bar.dataset.hasFree === 'true';
      upsells.forEach(function (up) {
        var vEl = $('[data-upsell-variant]', up);
        var opt = vEl.tagName === 'SELECT' ? vEl.options[vEl.selectedIndex] : vEl;
        var price = parseInt(opt.dataset.price, 10) || 0;
        var compare = parseInt(opt.dataset.compare, 10) || 0;
        var isFree = freeOn && up.dataset.freeGift === 'true';
        var label = $('[data-upsell-label]', up);
        var priceEl = $('[data-upsell-price]', up), cmpEl = $('[data-upsell-compare]', up);
        up.classList.toggle('is-free', isFree);
        if (isFree) {
          label.textContent = label.dataset.freeLabel;
          priceEl.textContent = 'FREE';
          cmpEl.textContent = formatMoney(Math.max(price, compare)); cmpEl.hidden = false;
          var cb = $('[data-upsell-check]', up); cb.checked = true; up.classList.add('is-checked');
        } else {
          label.textContent = label.dataset.label;
          priceEl.textContent = formatMoney(price);
          cmpEl.textContent = compare > price ? formatMoney(compare) : '';
          cmpEl.hidden = !(compare > price);
        }
      });
    }

    function refresh() {
      var cur = getCurrent();
      var base = cur.price, cmp = Math.max(cur.compare_at_price || 0, cur.price);
      bars.forEach(function (bar) {
        var qty = parseInt(bar.dataset.qty, 10);
        var pct = parseInt(bar.dataset.discount, 10) || 0;
        var total = Math.round(base * qty * (100 - pct) / 100);
        var compareTotal = cmp * qty;
        var saved = compareTotal - total;
        var savedPct = compareTotal ? Math.round(saved * 100 / compareTotal) : 0;
        var p = $('[data-bar-price]', bar); if (p) p.textContent = formatMoney(total);
        var c = $('[data-bar-compare]', bar); if (c) c.textContent = formatMoney(compareTotal);
        $$('[data-bar-saved]', bar).forEach(function (e) { e.textContent = formatMoney(saved).replace(/\.00(?!\d)/, ''); });
        $$('[data-bar-pct]', bar).forEach(function (e) { e.textContent = savedPct + '%'; });
        if (bar.classList.contains('is-selected')) buildItemRows(bar);
        else { var box = $('[data-bar-items]', bar); if (box) box.innerHTML = ''; }
      });
      refreshUpsellPrices();
    }

    function items() {
      var bar = selectedBar();
      var qty = parseInt(bar.dataset.qty, 10);
      var cur = getCurrent();
      var list = {};
      var ids = qty > 1 && itemSelections[qty] ? itemSelections[qty].slice(0, qty) : [];
      while (ids.length < qty) ids.push(cur.id);
      ids[0] = cur.id;
      ids.forEach(function (id) { list[id] = (list[id] || 0) + 1; });
      var out = Object.keys(list).map(function (id) { return { id: parseInt(id, 10), quantity: list[id] }; });
      upsells.forEach(function (up) {
        var cb = $('[data-upsell-check]', up);
        if (!cb || !cb.checked) return;
        var vEl = $('[data-upsell-variant]', up);
        out.push({ id: parseInt(vEl.value, 10), quantity: 1 });
      });
      return out;
    }

    refresh();
    return { refresh: refresh, items: items };
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCountdown();
    initRotators();
    $$('[data-product-section]').forEach(initProduct);
    if ($('[data-cart-timer]')) startCartTimer();
    try { if (sessionStorage.getItem('addon-note')) { sessionStorage.removeItem('addon-note'); $$('[data-addon-note]').forEach(function (n) { n.hidden = false; }); } } catch (e) {}
    checkCart().catch(function () {});
  });
})();
